import JalaaliUtils from '@date-io/jalaali';

class JalaaliUtcUtils extends JalaaliUtils {
  format(value, formatString) {
    return this.moment(value).format(formatString);
  }

  parse(value, format) {
    if (value === '') {
      return null;
    }

    return this.moment.utc(value, format, true);
  }

  date(value) {
    if (value === null) {
      return null;
    }

    const moment = this.moment(value);
    moment.locale(this.locale);

    return moment;
  }
}

export default JalaaliUtcUtils;
